export const DASHBOARD_ONE_COLUMN_BREAKPOINT_PX = 1024;

export const DASHBOARD_GRID_CLASS_NAME =
  'flex w-full max-w-[1560px] items-start gap-5 max-[1024px]:grid max-[1024px]:grid-cols-1';

export const DASHBOARD_COLUMN_CLASS_NAME =
  'flex w-full flex-1 flex-col gap-5 max-[1024px]:contents';

export const DASHBOARD_SECTIONS_IN_ONE_COLUMN_ORDER = [
  'todaySummary',
  'reviewInquiry',
  'orderSituation',
  'amountInfo',
  'newsBriefing',
  'blogPreview',
  'sellerboxAi',
] as const;

export type DashboardSection = (typeof DASHBOARD_SECTIONS_IN_ONE_COLUMN_ORDER)[number];

export const dashboardSectionClassNames: Record<DashboardSection, string> = {
  todaySummary: 'max-[1024px]:order-1',
  reviewInquiry: 'max-[1024px]:order-2',
  orderSituation: 'max-[1024px]:order-3',
  amountInfo: 'max-[1024px]:order-4',
  newsBriefing: 'max-[1024px]:order-5',
  blogPreview: 'max-[1024px]:order-6',
  sellerboxAi: 'max-[1024px]:order-7',
};
